var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.comments),function(comment){return _c('div',{key:comment.id},[_c('comment-display',{attrs:{"item":_vm.item,"comment":comment}}),_vm._v(" "),_c('v-divider',{staticClass:"mx-2 mt-4"})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }